<template>
  <UnauthorizedBlock class="text-center">
    <template v-if="status === 'verifying'">
      <div class="text-xl font-bold text-text leading-tight mb-6">{{ $t('verifying') }}</div>
      <div class="text-md font-medium text-text leading-tight">
        <font-awesome-icon icon="circle-notch" spin size="3x"/>
      </div>
    </template>
    <template v-else-if="status === 'error'">
      <div class="text-xl font-bold text-text leading-tight mb-6">{{ $t('verifyError') }}</div>
      <div class="text-md font-medium text-text leading-tight">{{ status_error }}</div>
    </template>
    <template v-else-if="status === 'success'">
      <div class="text-xl font-bold text-text leading-tight mb-6">{{ $t('verifySuccess') }}</div>
      <div class="text-md font-medium text-text leading-tight">
        {{ $t('verifySuccessText') }}
      </div>
    </template>
  </UnauthorizedBlock>
</template>

<script>
import {mapActions} from "vuex";
import UnauthorizedBlock from "@/components/layouts/common/UnauthorizedBlock";

export default {
  name: "MailVerification",
  components: {UnauthorizedBlock},
  data() {
    return {
      status: 'verifying',
      status_error: '',
    }
  },
  methods: {
    ...mapActions('auth', ['verifyEmail']),
    async verify() {
      if (!!this.$route.params.token) {
        return await this.verifyEmail({token: this.$route.params.token})
      } else {
        return {
          body: {
            success: false,
            message: 'Что-то пошло не так...'
          }
        }
      }
    }
  },
  async created() {
    let verifier = await this.verify();
    if (verifier.body.success) {
      this.status = 'success';
      //push user to another page
      setTimeout(() => {
        if (!!this.$cookies.get('_refresh_token')) {
          this.$router.push({name: 'login'})
        } else {
          this.$router.push({name: 'home'})
        }
      }, 1000)
    } else {
      this.status = 'error';
      this.status_error = verifier.body.message;
    }
  },
  i18n: {
    messages: {
      en: {
        verifying: 'Verifying',
        verifyError: 'Verifying error',
        verifySuccess: 'Verification passed successfully',
        verifySuccessText: 'Welcome to Money Keeper!'
      },
      ru: {
        verifying: 'Происходит верификация',
        verifyError: 'Ошибка верификации',
        verifySuccess: 'Верификация прошла успешно',
        verifySuccessText: 'Добро пожаловать в Money Keeper!'
      }
    }
  }
}
</script>